module.exports = __webpack_public_path__ + "img/succ-1.4c5d39db.png";